/**
 * Response Status filter options for the non-ePA and Pending worklists.
 *
 * Derived from {@link NON_EPA_RESPONSE_STATUSES}, which covers both CMM/STP
 * statuses and the Call Summary modal's writable response statuses.
 */

import { NON_EPA_RESPONSE_STATUSES } from "../worklistFilterNodes";

export const allResponseStatusOptions = NON_EPA_RESPONSE_STATUSES.map(
  (status) => ({
    label: status,
    value: status,
  }),
);
